import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import { KeyValue } from '@/main/models/common';
import React from 'react'
import LoginRecoveryPasswordQualitas from './LoginRecoveryPasswordQualitas';
import WrappedLoginAreaQualitas from './LoginAreaQualitas';
import QualitasLogo from '@/main/assets/images/login/logo-qualitas.png';
import { ArrowBack } from '@mui/icons-material';
import * as S from './styles';
import { IconButton } from '@mui/material';

interface ILoginScreenQualitasProps {
  translatesLocal: KeyValue[];
  hasRecoveryPassword: boolean;
  isLoadingTranslates: boolean;
  toggleRecoveryPassword: () => void;
}

function LoginScreenQualitas({
  translatesLocal,
  hasRecoveryPassword,
  isLoadingTranslates,
  toggleRecoveryPassword,
}: ILoginScreenQualitasProps) {

  function renderContent() {
    if (isLoadingTranslates) {
      return <LoadingComponent />;
    }
    return hasRecoveryPassword ? (
      <LoginRecoveryPasswordQualitas
        toggleRecoveryPassword={toggleRecoveryPassword}
        translatesLocal={translatesLocal}
      />
    ) : (
      <WrappedLoginAreaQualitas
        toggleRecoveryPassword={toggleRecoveryPassword}
        translatesLocal={translatesLocal}
      />
    );
  }


  return (
    <S.Container>
      <S.LoginCard>
        <S.AreaBackButton>
          <IconButton onClick={() => window.history.back()} >
            <S.BackButton>
              <ArrowBack fontSize='medium' />
            </S.BackButton>
          </IconButton>
        </S.AreaBackButton>
        <S.AreaLogo>
          <img src={QualitasLogo} alt="Qualitas Logo" />
        </S.AreaLogo>
        {renderContent()}
      </S.LoginCard>
    </S.Container>
  )
}

export default LoginScreenQualitas